import { createUseStyles } from 'react-jss';
import { BreakPointsMedia } from '../../../../foundation/responsive/responsive/index.js';

const truncatedText = {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
};
const multiLineTruncatedText = {
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 'var(--max-visible-row-count)',
    overflow: 'hidden',
};
const useStyles = createUseStyles({
    root: {
        '--max-visible-row-count': ({ preventNextLine, maxVisibleLinesCount }) => !preventNextLine && maxVisibleLinesCount && `${maxVisibleLinesCount}`,
        width: ({ isFullWidth }) => isFullWidth && '100%',
        maxWidth: '100%',
        fontSize: ({ sizes }) => sizes.Default.value?.fontSize,
        lineHeight: ({ sizes }) => `${sizes.Default.value?.lineHeight}`,
        fontWeight: ({ weight }) => weight,
        color: ({ color }) => color,
        textAlign: ({ align }) => align,
        extend: ({ preventNextLine, maxVisibleLinesCount }) => {
            if (preventNextLine)
                return { ...truncatedText };
            if (!preventNextLine && maxVisibleLinesCount) {
                return { ...multiLineTruncatedText };
            }
        },
        [BreakPointsMedia.XXL]: {
            fontSize: ({ sizes }) => sizes.XXL.value?.fontSize,
            lineHeight: ({ sizes }) => sizes.XXL.value?.lineHeight,
        },
        [BreakPointsMedia.XL]: {
            fontSize: ({ sizes }) => sizes.XL.value?.fontSize,
            lineHeight: ({ sizes }) => sizes.XL.value?.lineHeight,
        },
        [BreakPointsMedia.LG]: {
            fontSize: ({ sizes }) => sizes.LG.value?.fontSize,
            lineHeight: ({ sizes }) => sizes.LG.value?.lineHeight,
        },
        [BreakPointsMedia.MD]: {
            fontSize: ({ sizes }) => sizes.MD.value?.fontSize,
            lineHeight: ({ sizes }) => sizes.MD.value?.lineHeight,
        },
        [BreakPointsMedia.SM]: {
            fontSize: ({ sizes }) => sizes.SM.value?.fontSize,
            lineHeight: ({ sizes }) => sizes.SM.value?.lineHeight,
        },
        [BreakPointsMedia.XS]: {
            fontSize: ({ sizes }) => sizes.XS.value?.fontSize,
            lineHeight: ({ sizes }) => sizes.XS.value?.lineHeight,
        },
        [BreakPointsMedia.XXS]: {
            fontSize: ({ sizes }) => sizes.XXS.value?.fontSize,
            lineHeight: ({ sizes }) => sizes.XXS.value?.lineHeight,
        },
    },
}, {
    name: 'text',
});

export { useStyles };
